import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["self_assessment", "self_assessment_fields", "first_level", "second_level", "third_level", "fourth_level"]

  connect() {
    this.toggleComments()
  }

  showSelectedDescription(answer) {
    const questionGroup = answer.closest(".question-group")

    if (!questionGroup) {
      return
    }

    questionGroup.querySelectorAll(".description small").forEach((description) => {
      description.style.display = "none"
    })

    const selectedDescription = questionGroup.querySelector(`.description_${answer.value}`)
    if (selectedDescription) {
      selectedDescription.style.display = "block"
    }
  }

  toggleComments() {
    if (!this.hasSelf_assessment_fieldsTarget) return
    const selectedValues = this.self_assessment_fieldsTarget.querySelectorAll("input[type=radio]:checked")
    selectedValues.forEach((answer) => this.showSelectedDescription(answer))

  }

  calculateResults() {
    if (this.hasSelf_assessmentTarget) {
        let firstLevel = 0
        let secondLevel = 0
        let thirdLevel = 0
        let fourthLevel = 0
        let totalItems = Number(this.self_assessmentTarget.dataset.count)
        if (!totalItems) return

        const selectedValues = this.self_assessment_fieldsTarget.querySelectorAll("input[type=radio]:checked")
        selectedValues.forEach((answer) => {
            this.showSelectedDescription(answer)

            if(answer.value == 1) {
                firstLevel += 1
            } else if (answer.value == 2) {
                secondLevel += 1
            } else if (answer.value == 3) {
                thirdLevel += 1
            } else if (answer.value == 4) {
                fourthLevel += 1
            }
        })

        let firstLevelPercentage = (firstLevel / totalItems * 100)
        let secondLevelPercentage = (secondLevel / totalItems * 100)
        let thirdLevelPercentage = (thirdLevel / totalItems * 100)
        let fourthLevelPercentage = (fourthLevel / totalItems * 100)

        this.first_levelTarget.textContent = (firstLevelPercentage + secondLevelPercentage + thirdLevelPercentage + fourthLevelPercentage).toFixed(0) + "%"
        this.second_levelTarget.textContent = (secondLevelPercentage + thirdLevelPercentage + fourthLevelPercentage).toFixed(0) + "%"
        this.third_levelTarget.textContent = (thirdLevelPercentage + fourthLevelPercentage).toFixed(0) + "%"
        this.fourth_levelTarget.textContent = (fourthLevelPercentage).toFixed(0) + "%"
    }
}
}
